import {
  QualityControlFlag,
  getFlagFields,
  getQualityControlFlagTitle,
} from '@aloft/toolkit-shared';

import { QualityControlReviewFormCard } from './QualityControlReviewFormCard.tsx';

export const QualityControlReviewForm = ({
  flag,
  index,
  defaultExpanded = false,
  onResolveFlag,
}: {
  flag: QualityControlFlag;
  index: number;
  defaultExpanded?: boolean;
  onResolveFlag: (flag: QualityControlFlag) => void;
}) => {
  const title = `${index}. ${getQualityControlFlagTitle(flag.category)}`;
  const fieldTitles = getFlagFields(flag);

  return (
    <QualityControlReviewFormCard
      title={title}
      fieldTitles={fieldTitles}
      defaultExpanded={defaultExpanded}
      isResolved={flag.status === 'resolved'}
      onFieldBlur={() => onResolveFlag(flag)}
    />
  );
};
